import IconTitleComponent from './IconTitle.component';

export * from './IconTitle.component';
export default IconTitleComponent;
